import { useEffect } from 'react';

// Prefetch the 8 most-visited page chunks during browser idle time.
// Calling import() on already-loaded modules is a no-op (browser cache hit).
const PREFETCH_IMPORTS: Array<() => Promise<unknown>> = [
  () => import('../pages/Dashboard'),
  () => import('../pages/EmployeePortal/Dashboard'),
  () => import('../pages/StudentPortal/Dashboard'),
  () => import('../pages/Students'),
  () => import('../pages/Employees'),
  () => import('../pages/Attendance/StudentAttendancePage'),
  () => import('../pages/Attendance/EmployeeAttendancePage'),
  () => import('../pages/Classes'),
];

export function usePrefetchRoutes(): void {
  useEffect(() => {
    const prefetchAll = () => {
      for (const prefetch of PREFETCH_IMPORTS) {
        prefetch().catch(() => {
          // Prefetch failures are silent — they don't affect the user
        });
      }
    };

    const usingIdleCallback = typeof requestIdleCallback !== 'undefined';

    if (usingIdleCallback) {
      const id = requestIdleCallback(prefetchAll);
      return () => cancelIdleCallback(id);
    } else {
      const id = setTimeout(prefetchAll, 200);
      return () => clearTimeout(id);
    }
  }, []);
}
